import React, { useState } from "react";
import { connect } from "react-redux";
import styles from "./Sidebar.module.scss";
import PaginationComponent from "../Pagination/Pagination";
import ReactPlayer from "react-player";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import { makeStyles } from "@material-ui/core/styles";
import ThumbDownIcon from "@material-ui/icons/ThumbDown";
import ThumbUpIcon from "@material-ui/icons/ThumbUp";
import Button from "@material-ui/core/Button";
import AutoRotatingCarouselModal from "../../components/autoRotatingCarusel";
import CommentsItems from "./Comments";
import { ProtectedComponent } from "../../helpers/Protected/ProtectedComponent";
import ModalWindowWrapper from "../CommonComponents/ModalWindowWrapper";
import EditMapContent from "../CommonComponents/ModalWindowWrapper/content/EditMapContent";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";

const useStyles = makeStyles((theme) => ({
    toggleContainer: {
        margin: theme.spacing(2, 0),
        backgroundColor: "white",
    },
    root: {
        display: "flex",
        justifyContent: "flex-end",
    },
    button: {
        color: "rgba(0, 0, 0, 0.38)",
        height: "48px",
        border: "none",
    },
    textarea: {
        borderRadius: "10px",
        maxWidth: "100%",
        border: "transparent",
        color: "black",
        padding: "10px",
        boxSizing: "border-box",
        overflow: "hidden",
        minHeight: "40px",
        width: "100%",
        minWidth: "100%",
        paddingRight: "42px",
        border: "1px solid #c4c4c4",
    },
    errors: {
        border: "1px solid red",
    },
    commentsButton: {
        padding: "0",
        border: "none",
        height: "fit-content",
        margin: "10px",
    },
    edit: {
        display: "flex",
        justifyContent: "flex-end",
    },
}));

const SidebarData = (props) => {
    const matches = useMediaQuery("(max-width:600px)");
    const classes = useStyles();

    const [isModalOpen, setIsModalOpen] = useState(false);

    const renderEditModal = isModalOpen ? (
        <ProtectedComponent user={props.me} onlyAuth>
            <ModalWindowWrapper
                title={"Annotate Map"}
                content={
                    <EditMapContent
                        mark={props.mark}
                        onClose={() => setIsModalOpen(false)}
                        refreshMarkItemHandler={props.refreshMarkItemHandler}
                    />
                }
                onClose={() => setIsModalOpen(false)}
            />
        </ProtectedComponent>
    ) : null;

    const contributors = () =>
        props.mark.contributors.reduce(
            (acc, curr, i) => (!i ? curr.name : `${acc}, ${curr.name}`),
            ""
        );

    return (
        <React.Fragment>
            {renderEditModal}
            {props.mark && props.mark.title && !props.loading ? (
                <div className={styles.SidebarDataWrapper}>
                    <div className={styles.Close}>
                        <CloseOutlinedIcon
                            onClick={() => props.handleClose()}
                        />
                    </div>
                    <h4 className={styles.title}>
                        {props.mark && props.mark.title}
                    </h4>

                    {props.mark &&
                    props.mark.tags &&
                    props.mark.tags.length > 0 ? (
                        <div className={styles.TagsBlock}>
                            {props.mark.tags.map((item) => (
                                <div className={styles.TagsItems} key={item.id}>
                                    {item.name}
                                </div>
                            ))}
                        </div>
                    ) : (
                        <>
                            <br />
                            <br />
                        </>
                    )}

                    {props.mark &&
                        props.mark.media &&
                        props.photos.length > 0 && (
                            <React.Fragment>
                                {/*<Button onClick={props.handleClick}>Open pictures</Button>*/}

                                <div
                                    className={styles.ImgBlock}
                                    onClick={props.handleClick}
                                >
                                    {props.photos.map((item) => {
                                        return (
                                            <img
                                                className={styles.Prev}
                                                src={item.path_url}
                                                key={item.path_url}
                                            />
                                        );
                                    })}
                                </div>
                                <br />
                                <AutoRotatingCarouselModal
                                    handleClose={props.handleClose}
                                    img={props.photos}
                                    isMobile={matches}
                                    handleOpen={props.handleOpen}
                                    setHandleOpen={props.setHandleOpen}
                                />
                            </React.Fragment>
                        )}
                    {props.mark && props.mark.description ? (
                        <div className={styles.Description}>
                            {props.mark.description}
                        </div>
                    ) : null}

                    {props.mark &&
                        props.mark.media &&
                        props.videoArray.length > 0 && (
                            <React.Fragment>
                                {props.videoArray.map((item) => {
                                    return (
                                        <div
                                            className={styles.Video}
                                            key={item.id}
                                        >
                                            <ReactPlayer
                                                style={{
                                                    marginBottom: "26px",
                                                    maxHeight: "150px",
                                                }}
                                                url={item.url}
                                                width="100%"
                                            />
                                        </div>
                                    );
                                })}
                            </React.Fragment>
                        )}
                    <ProtectedComponent user={props.me} onlyAuth>
                        <div className={classes.edit}>
                            <Button
                                style={{ borderBottom: "4px solid #3BBDE3" }}
                                onClick={() => setIsModalOpen(true)}
                            >
                                Edit
                            </Button>
                        </div>
                    </ProtectedComponent>
                    <div className={styles.LikeBlock}>
                        <ToggleButtonGroup
                            aria-label="text alignment"
                            className={classes.root}
                        >
                            <ToggleButton
                                value="1"
                                className={classes.commentsButton}
                                onClick={() =>
                                    props.likeHandler(
                                        "1",
                                        "MarkItem",
                                        props.mark
                                    )
                                }
                            >
                                <ThumbUpIcon style={{ color: "#3BBDE3" }} />
                            </ToggleButton>
                            <ToggleButton
                                className={classes.commentsButton}
                                value="-1"
                                onClick={() =>
                                    props.likeHandler(
                                        "-1",
                                        "MarkItem",
                                        props.mark
                                    )
                                }
                            >
                                <ThumbDownIcon style={{ color: "#FC2A3A" }} />
                            </ToggleButton>
                        </ToggleButtonGroup>
                        <div className={styles.TotalCount}>
                            <span>
                                {props.mark.likes_count
                                    ? props.mark.likes_count
                                    : "0"}
                            </span>
                        </div>
                    </div>
                    <div className={styles.Contributors}>
                        Contributions by: {contributors()}
                    </div>
                    <br />
                    <div
                        className={`${styles.CommentWrapper} `}
                        ref={props.commentsRef}
                    >
                        <TextareaAutosize
                            className={`${classes.textarea} ${
                                props.errors && props.errors.message
                                    ? classes.errors
                                    : ""
                            }`}
                            rowsMin={3}
                            placeholder="Enter your comment"
                            onChange={props.commentsHandler}
                            value={props.comment}
                        />
                        <img
                            src={props.send}
                            alt="send"
                            className={styles.Send}
                            onClick={() => props.sendComment(props.mark)}
                        />
                        {!props.me.access_token &&
                            props.errors &&
                            props.errors.message && (
                                <div className={styles.Unauthorized}>
                                    {props.errors.message === "Unauthenticated."
                                        ? "Please login or register to comment."
                                        : props.errors.message}
                                </div>
                            )}
                    </div>
                    {props.errors &&
                        props.errors.errors &&
                        props.errors.errors.value && (
                            <div className={styles.CommentError}>
                                {props.errors.errors.value}
                            </div>
                        )}
                    {props.comments &&
                    props.comments.data &&
                    props.comments.data.length > 0 ? (
                        <div className={styles.CommentsBlock}>
                            {props.comments.data.map((item) => {
                                return (
                                    <CommentsItems
                                        item={item}
                                        key={item.id}
                                        likeHandler={props.likeHandler}
                                    />
                                );
                            })}
                            {+props.comments.total >
                                +props.comments.per_page && (
                                <PaginationComponent
                                    activePage={+props.comments.current_page}
                                    itemsCountPerPage={+props.comments.per_page}
                                    totalItemsCount={+props.comments.total}
                                    onChange={props.handlePageChange}
                                    handleScrollTop={props.handleScrollTop}
                                />
                            )}
                        </div>
                    ) : null}
                </div>
            ) : (
                <div className="loader"></div>
            )}
        </React.Fragment>
    );
};

const mapStateToProps = (state) => {
    return {
        mark: state.marks.mark,
        me: state.auth.me,
        comment: state.likes.comment,
        comments: state.likes.comments,
        errors: state.likes.errors,
    };
};

export default connect(mapStateToProps)(SidebarData);
